import { Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { TOTPManagement } from "@/components/TOTPManagement";

interface TwoFactorAuthSectionProps {
    totpEnabled: boolean;
    onDisable: () => void;
    onEnable: () => void;
}

export function TwoFactorAuthSection({
    totpEnabled,
    onDisable,
    onEnable
}: TwoFactorAuthSectionProps) {
    return (
        <Card className="glass-card p-6 space-y-8">
            <div>
                <div className="flex items-center gap-3 mb-4">
                    <div className="p-2 bg-primary/10 rounded-lg">
                        <Shield className="w-6 h-6 text-primary" />
                    </div>
                    <div>
                        <h3 className="text-lg font-semibold">Two-Factor Authentication</h3>
                        <p className="text-sm text-muted-foreground">
                            Add an extra layer of security to your account
                        </p>
                    </div>
                </div>

                <div className="pl-0 md:pl-14">
                    {totpEnabled ? (
                        <TOTPManagement enabled={totpEnabled} onDisable={onDisable} />
                    ) : (
                        <div>
                            <Button onClick={onEnable} className="gradient-primary">
                                Enable Two Factor Authentication
                            </Button>
                            <p className="text-sm text-muted-foreground mb-4 border-top pt-2">
                                Add an extra layer of security. Use your authenticator app to verify your
                                identity at login.
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </Card>
    );
}
